import ApeironComponent from '@/components/commons/apeiron-component.model';
import { ActividadRetribucion, TestimonioRetribucion } from '@/shared/model/ars/ars.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { maxLength, required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    testimonioForm: {
      aprendizaje: { required, maxLength: maxLength(500) },
    },
  };
};

@Component({
  validations,
})
export default class ActividadTestimonioArsComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  public testimonioForm: TestimonioRetribucion = new TestimonioRetribucion(); // se pobla con los datos del property

  public guardarTestimonio(): void {
    this.$emit('submit', { testimonioRetribucion: this.testimonioForm });
  }

  public mounted(): void {
    if (this.solicitud && this.solicitud.testimonioRetribucion) {
      this.testimonioForm = TestimonioRetribucion.fromObject(this.solicitud.testimonioRetribucion);
    }
  }

  get esReadOnly(): boolean {
    return this.readOnly;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  get desactivarBoton(): boolean {
    return this.$v.$invalid;
  }
}
